import { Avatar, Grid, Stack } from "@mui/material";
import React from "react";
import FormPageHeader from "../../utilities/FormPageHeader";
import "../expense-claim/expenseClaim.css";

const ExitEmployee = () => {
  return (
    <React.Fragment>
      <FormPageHeader
        componentName="List"
        pageName="End Of Service Settlement"
        currentPage="End Of Service Settlement"
      />
      <h3 className="p-10 my-4">General Details :</h3>
      <Grid container spacing={1} className="w-full p-10 my-4">
        <Grid item xs={1}></Grid>

        <Grid item xs={3}>
          <Avatar
            src="https://uschamber-co.imgix.net/https%3A%2F%2Fs3.us-east-1.amazonaws.com%2Fco-assets%2Fassets%2Fimages%2FLegal-Requirements-Hiring-Employees.jpg?auto=compress%2Cformat&crop=focalpoint&fit=crop&fp-x=0.4754&fp-y=0.3321&h=415&q=88&w=622&s=de4e8920342f8a282aadb2e0aef49ef6"
            alt="img"
            sx={{ width: 150, height: 150 }}
          />
        </Grid>
        <Grid item xs={2}></Grid>
        <Grid
          item
          xs={6}
          sx={{ border: "2px whitesmoke solid", padding: "8px !important" }}
        >
          <div className="p-3 m-3">
            <h3 style={{ borderBottom: "1px whitesmoke solid", padding: 1 }}>
              Employee Name Here
            </h3>
            <Grid container spacing={1} sx={{ padding: 1 }}>
              <Grid item xs={6}>
                Employee Code
              </Grid>
              <Grid item xs={6}>
                19
              </Grid>
              <Grid item xs={6}>
                Department
              </Grid>
              <Grid item xs={6}>
                SOP
              </Grid>
              <Grid item xs={6}>
                Designation
              </Grid>
              <Grid item xs={6}>
                Sales Order Processing
              </Grid>
              <Grid item xs={6}>
                Nationality
              </Grid>
              <Grid item xs={6}>
                Jordan
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
      <h3 className="p-10 my-4">Separation Details :</h3>
      <Grid
        container
        spacing={1}
        className="w-full p-10 my-4"
        sx={{
          borderTop: "2px whitesmoke solid",
          borderBottom: "2px whitesmoke solid",
          margin: "5px 0px",
        }}
      >
        <Grid item xs={4} sx={{ padding: 0 }}>
          {/* Separation Details : */}
          <div className="mb-4">Contract Type: Limited</div>
          <div>Separation Type: Resignation</div>
        </Grid>
        <Grid item xs={4} sx={{ padding: 0 }}>
          <div className="mb-4">Separation Date: 31.08.2023</div>
          <div>Last Working Date: 30.09.2023</div>
        </Grid>
        <Grid item xs={4} sx={{ padding: 0 }}>
          <div className="mb-4">Service Period: 3 Year(s) 6 Month(s)</div>
        </Grid>
        <Grid item xs={4} sx={{ padding: 0, margin: "10px 0px" }}>
          {/* Separation Details : */}
          <div className="mb-4">Joined On: 01.03.2020</div>
          <div>Current Pay Period: Sep 2023</div>
        </Grid>
        <Grid item xs={4} sx={{ padding: 0, margin: "10px 0px" }}>
          <div className="mb-4">Pay Group: NOLTE FZE</div>
          <div>From: 01.09.2023</div>
        </Grid>
        <Grid item xs={4} sx={{ padding: 0, margin: "10px 0px" }}>
          <div className="mb-4">Last Process till: 30.09.2023</div>
          <div>To: 30.09.2023</div>
        </Grid>
      </Grid>
      <h3 className="p-10 my-4 ">REMUNERATION : (01.09.2023 - 30.09.2023)</h3>

      <Grid
        container
        spacing={1}
        className="w-full p-10 my-4"
        sx={{
          border: "1px whitesmoke solid",
          margin: "5px 0px",
        }}
      >
        <Grid item xs={1}></Grid>
        <Grid item xs={5}>
          <Stack className="my-2">Basic</Stack>
          <Stack className="my-2">Housing</Stack>
          <Stack className="my-2">Transport / Others</Stack>
          <Stack className="my-2">Car</Stack>
          <Stack className="my-2">Flight Allowance</Stack>
          <Stack sx={{ margin: "10px 0px", fontWeight: "bold" }}>
            Amount Payable
          </Stack>
        </Grid>
        <Grid item xs={1}>
          <Stack className="my-2">8,000.00</Stack>
          <Stack className="my-2">1,000.00</Stack>
          <Stack className="my-2">1,000.00</Stack>
          <Stack className="my-2">-</Stack>
          <Stack className="my-2">-</Stack>
          <Stack
            sx={{
              margin: "10px 0px",
              fontWeight: "bold",
              borderBottom: "1px solid whitesmoke",
            }}
          >
            10,000.00
          </Stack>
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>
      <h3 className="p-10 my-4 ">Gratuity : As of 30.09.2023</h3>

      <Grid
        container
        spacing={1}
        className="w-full p-10 my-4"
        sx={{
          border: "1px whitesmoke solid",
          margin: "5px 0px",
        }}
      >
        <Grid item xs={5}>
          <Stack className="my-4">Basic Salary :</Stack>
          <Stack className="my-4">Number of days served:</Stack>
          <Stack>(01/03/2020 - 30/09/2023)</Stack>
        </Grid>
        <Grid item xs={3}>
          <Stack className="my-4">8,000.00</Stack>
          <Stack className="my-4">1,309 Days</Stack>
        </Grid>
        <Grid item xs={4}>
          <table>
            <thead>
              <tr>
                <th>From </th>
                <th>To </th>
                <th>Entitlement Per Year </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>0 Year</td>
                <td>{"< 1 Year"}</td>

                <td>0 Days</td>
              </tr>
              <tr>
                <td>{"> 1 Year"}</td>
                <td>{"< 5 Years"}</td>

                <td>21 Days</td>
              </tr>
              <tr>
                <td>{"< 5 Year"}</td>
                <td></td>

                <td>30 Days</td>
              </tr>
            </tbody>
          </table>
        </Grid>

        <Grid item xs={1} sx={{ margin: "0px 20px" }}>
          <Stack sx={{ margin: "5px" }}>01/03/2020</Stack>
          <Stack sx={{ margin: "5px" }}>01/03/2020</Stack>
          <Stack sx={{ margin: "5px" }}>01/03/2020</Stack>
          <Stack sx={{ margin: "5px" }}>01/03/2020</Stack>
        </Grid>
        <Grid item xs={3}>
          <Stack sx={{ margin: "5px" }}>31/12/2020</Stack>
          <Stack sx={{ margin: "5px" }}>31/12/2020</Stack>
          <Stack sx={{ margin: "5px" }}>31/12/2020</Stack>
          <Stack sx={{ margin: "5px" }}>31/12/2020</Stack>
        </Grid>
        <Grid item xs={1}>
          <Stack sx={{ margin: "5px" }}>365.00</Stack>
          <Stack sx={{ margin: "5px" }}>365.00</Stack>
          <Stack sx={{ margin: "5px" }}>365.00</Stack>
          <Stack sx={{ margin: "5px" }}>365.00</Stack>
        </Grid>
        <Grid item xs={1}>
          <Stack sx={{ margin: "5px" }}>5,600.00</Stack>
          <Stack sx={{ margin: "5px" }}>5,600.00</Stack>
          <Stack sx={{ margin: "5px" }}>5,600.00</Stack>
          <Stack sx={{ margin: "5px" }}>5,600.00</Stack>
        </Grid>
        <Grid item xs={4}></Grid>
        <Grid item xs={6}>
          <Stack className="my-4">Gross Gratuity :</Stack>
          <Stack className="my-4">Less Advances against Gratuity:</Stack>
          <Stack sx={{ margin: "10px 0px", fontWeight: "bold" }}>
            Amount Payable
          </Stack>
        </Grid>
        <Grid item xs={1}>
          <Stack className="my-4">20,083.00</Stack>
          <Stack className="my-4">-</Stack>
          <Stack
            sx={{
              margin: "10px 0px",
              fontWeight: "bold",
              borderBottom: "1px solid whitesmoke",
            }}
          >
            20,083.00
          </Stack>
        </Grid>
      </Grid>
      <h3 className="p-10 my-4 ">Leave Salary</h3>

      <Grid
        container
        spacing={1}
        className="w-full p-10 my-4"
        sx={{
          border: "1px whitesmoke solid",
          margin: "5px 0px",
        }}
      >
        <Grid item xs={1}></Grid>
        <Grid item xs={5}>
          <Stack className="my-2">Monthly Salary :</Stack>
          <Stack className="my-2">Unconsumed Leaves 2022</Stack>
          <Stack className="my-2">2023 Leave Entitlement</Stack>
          <Stack className="my-2">Less: Leaves Consumed</Stack>
          <Stack sx={{ marginTop: 1 }} className="font-bold">
            Balance no. of leaves till Sep 2023
          </Stack>
          <Stack sx={{ marginTop: 1 }} className="font-bold">
            Amount Payable
          </Stack>
        </Grid>
        <Grid item xs={1}>
          <Stack className="my-2">10,000.00</Stack>
          <Stack className="my-2">2.0 Days</Stack>
          <Stack className="my-2">11.0 Days</Stack>
          <Stack className="my-2">8.0 Days</Stack>

          <Stack sx={{ marginTop: 1 }} className="font-bold">
            5.0 Days
          </Stack>
          <Stack
            sx={{ marginTop: 1, borderBottom: "1px solid whitesmoke" }}
            className="font-bold"
          >
            1,644.00
          </Stack>
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>
      <h3 className="p-10 my-4 ">Bonus</h3>

      <Grid
        container
        spacing={1}
        className="w-full p-10 my-4"
        sx={{
          border: "1px whitesmoke solid",
          margin: "5px 0px",
        }}
      >
        <Grid item xs={1}></Grid>
        <Grid item xs={5}>
          <Stack className="my-4">Incentive for the year 2023</Stack>
          <Stack className="my-4">Less Advances against Bonus</Stack>

          <Stack sx={{ margin: "10px 0px", fontWeight: "bold" }}>
            Amount Payable
          </Stack>
        </Grid>
        <Grid item xs={1}>
          <Stack className="my-4">3,000.00</Stack>
          <Stack className="my-4">-</Stack>

          <Stack
            sx={{
              margin: "10px 0px",
              fontWeight: "bold",
              borderBottom: "1px solid whitesmoke",
            }}
          >
            3,000.00
          </Stack>
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>
      <h3 className="p-10 my-4 ">Deductions</h3>

      <Grid
        container
        spacing={1}
        className="w-full p-10 my-4"
        sx={{
          border: "1px whitesmoke solid",
          margin: "5px 0px",
        }}
      >
        <Grid item xs={1}></Grid>
        <Grid item xs={5}>
          <Stack className="my-4">Laptop Cost</Stack>
          <Stack className="my-4">Deduction of Advances 2023</Stack>

          <Stack sx={{ margin: "10px 0px", fontWeight: "bold" }}>
            Total Deduction
          </Stack>
        </Grid>
        <Grid item xs={1}>
          <Stack className="my-4">1,200.00</Stack>
          <Stack className="my-4">15,000.00</Stack>

          <Stack
            sx={{
              margin: "10px 0px",
              fontWeight: "bold",
              borderBottom: "1px solid whitesmoke",
            }}
          >
            16,200.00
          </Stack>
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>
      <div className="flex">
        <h3 className="p-10 my-4 font-medium">
          Total Amount Payable / Receivable by Nolte FZE
        </h3>
        <h3 className="p-10 my-4 font-medium" style={{ marginLeft: "13%" }}>
          18,527.00
        </h3>
      </div>
    </React.Fragment>
    // <table className="w-full">
    //   <tr
    //     style={{
    //       borderTop: "2px whitesmoke solid", padding:"8px !important",
    //       borderBottom: "2px whitesmoke solid", padding:"8px !important",
    //       display: "flex",
    //       justifyContent: "space-between",
    //     }}
    //   >
    //     <td>Code</td>
    //     <td>123</td>
    //   </tr>
    // </table>
  );
};

export default ExitEmployee;
